// extracted by mini-css-extract-plugin
export default {"groupForm":"AddClient_groupForm__uBYn8","btns":"AddClient_btns__I340+"};